import React from "react";
import { Card, CardTitle, CardDescription } from "@/components/ui";
import { CircleCheck } from "lucide-react";
import { clsx } from "clsx";

interface CardOptionProps {
  selected: boolean;
  title: string;
  description?: string;
}

export const CardOption = ({
  selected,
  title,
  description,
  ...props
}: CardOptionProps) => {
  return (
    <Card
      className={clsx(
        "bg-transparent shadow-xs transition-[color,box-shadow] hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:hover:bg-input/50",
        { "mx-[-1px] border-2 border-blue-primary": selected },
      )}
      aria-selected={selected}
      {...props}
    >
      <div className="flex px-4 py-3 text-left">
        <div className="flex grow flex-col">
          <CardTitle className="text-sm">
            <div className="flex">
              <p className="grow">{title}</p>
            </div>
          </CardTitle>
          {description ? (
            <CardDescription>{description}</CardDescription>
          ) : (
            <></>
          )}
        </div>
        <div className="w-4">
          {selected ? (
            <CircleCheck
              className="text-base"
              fill="var(--blue-primary)"
              color="white"
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </Card>
  );
};
